import { createCrewLookupSelect } from './createCrewLookupSelect';

export const MaritalStatusSelect = createCrewLookupSelect('MaritalStatusSelect', 'maritalStatuses');
export default MaritalStatusSelect;
